import type { Vehicle } from '@/types/domain';
import { useFirestoreDoc } from './useFirestoreDoc';

export function useVehicle(vehicleId: string | null | undefined) {
  return useFirestoreDoc<Vehicle>(vehicleId ? 'vehicles' : null, vehicleId ? [vehicleId] : []);
}
